import React from 'react';
import { observer } from 'mobx-react';
import { Box, Typography, Container } from '@mui/material';
import FeaturedCard from '../../components/featuredCard';
import FeaturedCardSkeleton from '../../components/featuredCardSkeleton';
import usePublisher from '../../../store/models/publisher/usePublisher';
import * as styles from './styles';

const SKELETON_COUNT = 3; // matches the grid's widest breakpoint (lg: 3 columns)

function renderSectionHeader(section) {
    return (
        <Box sx={styles.sectionHeader}>
            <Box>
                <Typography sx={styles.eyebrow}>{section.label}</Typography>
                <Typography variant="h2" sx={styles.title}>{section.title}</Typography>
                <Typography variant="body1" sx={styles.subtitle}>
                    {section.description}
                </Typography>
            </Box>
        </Box>
    );
}

function renderGrid(publishers, whatsHotPublisherIds, onSync, onShare) {
    return (
        <Box sx={styles.grid}>
            {publishers.map((publisher) => (
                <FeaturedCard
                    key={publisher.pubId}
                    publisher={publisher}
                    hotRank={whatsHotPublisherIds[String(publisher.pubId)]}
                    onSync={onSync}
                    onShare={onShare}
                />
            ))}
        </Box>
    );
}

function renderSkeletonGrid() {
    return (
        <Box sx={styles.grid}>
            {Array.from({ length: SKELETON_COUNT }, (_, i) => (
                <FeaturedCardSkeleton key={i} />
            ))}
        </Box>
    );
}

function Featured({ onSync, onShare }) {
    const { featuredPublishers, featuredSection, whatsHotPublisherIds, featuredPublishersLoading } = usePublisher();

    return (
        <Box component="section" sx={styles.section}>
            <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
                {renderSectionHeader(featuredSection)}
                {featuredPublishersLoading
                    ? renderSkeletonGrid()
                    : renderGrid(featuredPublishers, whatsHotPublisherIds, onSync, onShare)}
            </Container>
        </Box>
    );
}

export default observer(Featured);
